// File: src/context/AuthContext.js
// Description: Provides authentication context to manage user login status and session persistence.

import React, { createContext, useState, useEffect } from 'react';

// Create the AuthContext
export const AuthContext = createContext();

// AuthProvider wraps the app and provides authentication state and functions.
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // On mount, check if user data exists in localStorage for session persistence.
  useEffect(() => {
    const storedUser = localStorage.getItem('appUser');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  // Login function stores user data and persists it to localStorage.
  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('appUser', JSON.stringify(userData));
  };

  // Logout function clears the user data.
  const logout = () => {
    setUser(null);
    localStorage.removeItem('appUser');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
